// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '';
const CLIENT_DASHBOARD = '/cliente';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: '/',
  clientLogin: path(ROOTS_AUTH, '/cliente/login'),
  intranetLogin: path(ROOTS_AUTH, '/intranet/login'),
  mediatorLogin: path(ROOTS_AUTH, '/mediator/login'),
};

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  page404: '/404',
};

export const PATH_DASHBOARD = {
  root: CLIENT_DASHBOARD,
  clientDashboard: path(CLIENT_DASHBOARD, '/app'),
  bookings: {
    root: path(CLIENT_DASHBOARD, '/richieste'),
    new: path(CLIENT_DASHBOARD, '/richieste/nuova'),
    list: path(CLIENT_DASHBOARD, '/richieste/lista'),
    view: (id) => path(CLIENT_DASHBOARD, `/richieste/${id}`),
  },
  bookingCompleted: path(CLIENT_DASHBOARD, '/fatturazione'),

  clientProfile: path(CLIENT_DASHBOARD, '/profilo'),
};
